import { render, staticRenderFns } from "./PrimeiroAcesso.vue?vue&type=template&id=ae01abc0&scoped=true"
import script from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
export * from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
import style0 from "./PrimeiroAcesso.vue?vue&type=style&index=0&id=ae01abc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae01abc0",
  null
  
)

export default component.exports